import { PageListUL } from '../styles'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { MoreButton } from 'modules/app/styles'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledTooltip } from 'reactstrap'
import { CustomButton } from 'modules/auth/styles'
import { checkUser_for_admin_or_owner, checkUser_for_admin_or_owner_or_editor, consoleLog, copyLink, generateSlug, getTitle, handleApiError, uuidExtract } from 'utils/helpers'
import { history } from 'store/store'
import { toast } from 'react-toastify'
import { duplicatePage_api, getContentByUUID_api } from 'store/apis'
import UpgradeButton from 'modules/app/components/UpgradeButton'
import { Fragment, useState } from 'react'
import { connect } from 'react-redux'
import {
  pinToCategory_action,
  markAsFavorite_action,
  toggleShareModal_action,
  toggleMoveToCategoryModal_action,
  toggleContentPermissionModal_action,
  toggleDeleteContentModal_action,
  getDrafts_action,
  changeTab_action,
  toggleSettingsModal_action,
  getTotalItemsCount_action,
  createDraft_action,
  setSelectedPageOrDraft,
  setPageDropdownStatus,
  setPageDropdownPosition,
  setCurrentPageDropdown,
  setDropdownDirection
} from 'store/actions'
import { ReactComponent as PageIcon } from 'assets/images/icons/page.svg'
import { ReactComponent as DraftPageIcon } from 'assets/images/icons/draft_page.svg'
import { ReactComponent as PushPinIcon } from 'assets/images/icons/push_pin.svg'
import { ReactComponent as SharedPageIcon } from 'assets/images/icons/shared_page.svg'

import { useLocation } from 'react-router-dom'

export const CategoryContentPlaceholder = () => (
  <div className='ph-item py-2 px-0 m-0 border-0' style={{ backgroundColor: 'transparent' }}>
    <div className='ph-col-12 mb-0'>
      <div className='ph-row'>
        <div className='ph-col-6 big' style={{ backgroundColor: '#F0F0FF' }}></div>
      </div>
    </div>
  </div>
)

export function PagesList(props) {
  const { setSelectedPageOrDraft, setPageDropdownStatus, setPageDropdownPosition, setCurrentPageDropdown, setDropdownDirection, showPageDropdown, currentPageDropdown } = props

  const className = props.className || ''
  const { pathname } = useLocation();
  const openShareModal = (item) => {
    if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed) {
      props.toggleSettingsModal(true)
      props.changeTab('billing')
      history.push('/')
    } else {
      props.toggleShareModal(true, item)
    }
  }

  const getTooltip = (page, shared = '') => {
    const tooltip = `${shared ? `${shared}, ` : ''}${page.pinned_to_category ? 'Pinned to Category, ' : ''}${page.is_favorite ? 'Pinned (for you), ' : ''}`
    return tooltip.substring(0, tooltip.lastIndexOf(','))
  }

  const onEditPage = async (e, uuid) => {
    e.preventDefault()
    try {
      // Get latest published page
      const _uuid = uuidExtract(uuid)
      let _page = await getContentByUUID_api(_uuid)
      if (_page) {
        try {
          _page = { ..._page, category: _page.category || {} }
          const draft = await props.createDraft(_page, true)
          history.push(`/pages/drafts/edit/${generateSlug(draft)}`)
          props.getTotalItemsCount()
          props.getDrafts()
        } catch (error) {
          consoleLog(error)
        }
      }
    } catch (error) {
      handleApiError(error)
    }
  }

  const getCurrentUrlArrayLength = () => {
    return pathname?.split('/')?.length;
  }

  return (
    <PageListUL className={`${className}`} level={props.level}>
      {props.pages.map((page, i) => {
        return (
          <li
            className={`${!page.is_accessible ? 'disabled' : ''} ${props.showPageMeta ? 'with-page-meta' : ''} ${props.level > 1 ? `level-${props.level}` : ''}`}
            key={i}
            draggable
            onDragStart={(e) => e.dataTransfer.setData('dragingPage', JSON.stringify({ ...page, section: props.section }))}>
            {/* Published Page */}
            {!!!page.is_draft && (
              <div
                onClick={() => {
                  setSelectedPageOrDraft(page);
                  page.is_accessible && history.push(`/page/${generateSlug(page)}`)
                }}
                className={`content-link d-flex ${!props.showPageMeta ? 'align-items-center' : ''} ${(page?.id === props.selectedPageOrDraft?.id && getCurrentUrlArrayLength() !== 4) ? 'active' : ''}`}>
                {page.guest_sharing && page.guest_sharing.is_accessible ? (
                  <div>
                    <SharedPageIcon id={`shared${page.id}`} />
                    {getTooltip(page, 'Shared Externally') ? <UncontrolledTooltip target={`shared${page.id}`}>{getTooltip(page, 'Shared Externally')}</UncontrolledTooltip> : <></>}
                  </div>
                ) : (
                  <div>
                    {page.pinned_to_category && !props.isFavourite ? <PushPinIcon id={`page${page.id}`} /> : <PageIcon id={`page${page.id}`} />}
                    {getTooltip(page) ? <UncontrolledTooltip target={`page${page.id}`}>{getTooltip(page)}</UncontrolledTooltip> : <></>}
                  </div>
                )}
                <div dir='auto' className='ml-1 page-title'>
                  {getTitle(page.title)}
                </div>
              </div>
            )}
            {/* Draft */}
            {!!page.is_draft && (
              <Fragment>
                <div
                  onClick={() => {
                    setSelectedPageOrDraft(page);
                    page.is_accessible && history.push(`/pages/drafts/edit/${generateSlug(page)}`)
                  }}
                  className={`content-link d-flex ${!props.showPageMeta ? 'align-items-center' : ''} ${(page?.id === props.selectedPageOrDraft?.id && getCurrentUrlArrayLength() !== 4) ? 'active' : ''}`}>
                  <div>
                    <DraftPageIcon id={`draft${page.id}`} />
                    <UncontrolledTooltip target={`draft${page.id}`}>Draft</UncontrolledTooltip>
                  </div>
                  <div className='ml-1 page-title' dir='auto'>
                    {getTitle(page.title)}
                  </div>
                </div>
              </Fragment>
            )}

            {/* Disabled on Freemium */}
            {!page.is_accessible && <UpgradeButton />}

            <MoreButton className={`more-button-dropdown ${showPageDropdown && currentPageDropdown?.id === page?.id ? 'arrow' : ''}`} isOpen={showPageDropdown && currentPageDropdown?.id === page?.id} direction='right' toggle={(event) => {
              const sideMenu = document.querySelector('#pageScrollDiv')?.getBoundingClientRect();

              if (event.target.className !== 'dropdownChild') {
                setPageDropdownStatus(!showPageDropdown);

                const buttonRect = event.target.closest(`#pageDropdownButton-${page.id}`)?.getBoundingClientRect();

                const left = buttonRect?.left + buttonRect?.width - sideMenu?.left;
                const top = buttonRect?.top + window.scrollY - sideMenu?.top;

                if (sideMenu?.bottom - buttonRect?.bottom < 50) {
                  setPageDropdownPosition({ left, top: top - 30 });
                  setDropdownDirection('up');
                } else {
                  setPageDropdownPosition({ left, top: page.is_draft ? top : (top - 30) });
                  setDropdownDirection('down');
                }

                setPageDropdownStatus(!showPageDropdown);
                setCurrentPageDropdown(page);

                document.body.style.overflow = 'hidden';
              }
            }}>
              <DropdownToggle id={`pageDropdownButton-${page?.id}`} caret={false} tag='div'>
                <CustomButton type='button' className='toggle shadow-none'>
                  <MenuIcon />
                </CustomButton>
              </DropdownToggle>
              {/* <DropdownMenu>
                {page.is_accessible && (
                  <>
                    {!!!page.is_draft && checkUser_for_admin_or_owner_or_editor(page, props.user) && (
                      <DropdownItem className='border-bottom' onClick={(e) => onEditPage(e, page.uuid)}>
                        <EditIcon />
                        Edit
                      </DropdownItem>
                    )}
                    <DropdownItem
                      className='border-bottom'
                      onClick={async () => {
                        if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                          props.toggleSettingsModal(true)
                          props.changeTab('billing')
                          history.push('/')
                        } else {
                          const result = await duplicatePage_api(page.id)
                          props.getTotalItemsCount()
                          history.push(`/pages/drafts/edit/${generateSlug(result)}`)
                          props.getDrafts()
                        }
                      }}>
                      <DuplicateIcon />
                      {page.is_draft ? 'Duplicate' : 'Duplicate as Draft'}
                    </DropdownItem>
                  </>
                )}
                {!!!page.is_draft && (props.user.membership.user_type === 'admin' || props.who_can_share === 'members') && (
                  <DropdownItem className='border-bottom' onClick={() => openShareModal(page)}>
                    <ExternalIcon />
                    Share Externally
                  </DropdownItem>
                )}
                <DropdownItem
                  className='border-bottom'
                  onClick={() => {
                    copyLink(page)
                    toast.success('Link copied to clipboard!')
                  }}>
                  <CopyLinkIcon />
                  Copy Link
                </DropdownItem>
                {props.showMovetocategory && checkUser_for_admin_or_owner_or_editor(page, props.user) && (
                  <DropdownItem className='border-bottom' onClick={() => props.toggleMoveToCategoryModal(true, { uuid: page.uuid })}>
                    <MoveIcon />
                    Move to Category
                  </DropdownItem>
                )}
                {!page.is_draft && (
                  <DropdownItem className='border-bottom' onClick={() => props.markAsFavorite(page)}>
                    {page.is_favorite ? (
                      <>
                        <UnpinSvg />
                        <span>Unpin This File (For you)</span>
                      </>
                    ) : (
                      <>
                        <PinSvg />
                        <span>Pin This File (For you)</span>
                      </>
                    )}
                  </DropdownItem>
                )}
                {props.user.membership.user_type === 'admin' && !!!page.is_draft && page.category_id && (
                  <DropdownItem className='border-bottom' onClick={() => props.pinToCategory(page)}>
                    {page.pinned_to_category ? (
                      <>
                        <UnpinToCategoryIcon />
                        <span>Unpin to Category</span>
                      </>
                    ) : (
                      <>
                        <PinToCategoryIcon />
                        <span>Pin to Category</span>
                      </>
                    )}
                  </DropdownItem>
                )}
                {checkUser_for_admin_or_owner(page, props.user) && (
                  <>
                    {page.is_draft && (
                      <DropdownItem className='border-bottom' onClick={() => props.toggleContentPermissionModal(true, page)}>
                        <CollabrationIcon />
                        Collaborators
                      </DropdownItem>
                    )}
                    <DropdownItem tag='span' className='divider'>
                      {' '}
                    </DropdownItem>

                    <DropdownItem className='border-bottom text-danger delete' onClick={() => props.toggleDeleteContentModal(true, { ...page }, true)}>
                      {page.is_draft ? (
                        <>
                          <DeleteIcon height={24} width={24} />
                          <span>Delete</span>
                        </>
                      ) : (
                        <>
                          <UnpublishIcon />
                          <span>Unpublish</span>
                        </>
                      )}
                    </DropdownItem>
                  </>
                )}
              </DropdownMenu> */}
            </MoreButton>
          </li>
        )
      })}
      {props.loading_category_id === props.category_uuid && !props.pages.length && <CategoryContentPlaceholder />}
    </PageListUL>
  )
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count,
  loading_category_id: state.contents.loading_category_id,
  who_can_share: state.company.company.who_can_share,
  selectedPageOrDraft: state.contents.selectedPageOrDraft,

  showPageDropdown: state.app.isPageDropdownVisible,
  currentPageDropdown: state.app.currentPageDropdown
})

const mapDispatchToProps = (dispatch) => ({
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  markAsFavorite: (content) => dispatch(markAsFavorite_action(content)),
  pinToCategory: (content) => dispatch(pinToCategory_action(content)),
  getTotalItemsCount: () => dispatch(getTotalItemsCount_action()),
  toggleDeleteContentModal: (status, item, redirectToHome) => dispatch(toggleDeleteContentModal_action(status, item, redirectToHome)),
  toggleMoveToCategoryModal: (showMoveToCategoryModal, item) => dispatch(toggleMoveToCategoryModal_action(showMoveToCategoryModal, item)),
  toggleContentPermissionModal: (status, item) => dispatch(toggleContentPermissionModal_action(status, item)),
  getDrafts: () => new Promise((resolve, reject) => dispatch(getDrafts_action(resolve, reject))),
  toggleShareModal: (status, value) => dispatch(toggleShareModal_action(status, value)),
  createDraft: (data, isEditing) => new Promise((resolve, reject) => dispatch(createDraft_action(data, resolve, reject, isEditing))),
  setSelectedPageOrDraft: (page) => dispatch(setSelectedPageOrDraft(page)),

  setPageDropdownStatus: (status) => dispatch(setPageDropdownStatus(status)),
  setPageDropdownPosition: (position) => dispatch(setPageDropdownPosition(position)),
  setCurrentPageDropdown: (response) => dispatch(setCurrentPageDropdown(response)),
  setDropdownDirection: (status) => dispatch(setDropdownDirection(status)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PagesList)
